import { render, staticRenderFns } from "./personalInfoSidebar.vue?vue&type=template&id=9c3d984e&scoped=true"
import script from "./personalInfoSidebar.vue?vue&type=script&lang=js"
export * from "./personalInfoSidebar.vue?vue&type=script&lang=js"
import style0 from "./personalInfoSidebar.vue?vue&type=style&index=0&id=9c3d984e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3d984e",
  null
  
)

export default component.exports